export const DEFAULT_PARTICIPANTS_CATEGORY = 'adults'
export const DEFAULT_ADULTS_PARTICIPANTS = 2
export const DEFAULT_PARTICIPANTS_VALUES = {
  adults: {
    birthdates: [],
    number: 2
  },
  babies: {
    birthdates: [],
    number: 0
  },
  children: {
    birthdates: [],
    number: 0
  }
}
export const PARTICIPANTS_CATEGORIES = [DEFAULT_PARTICIPANTS_CATEGORY, 'children', 'babies']

export const DEFAULT_PARTICIPANTS_BIRTHDATES = PARTICIPANTS_CATEGORIES.reduce((participantsBirthdates, category) => {
  participantsBirthdates[category] = []
  return participantsBirthdates
}, {})
